import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { typographyCss } from 'common/typography';

type ItemOptionValueRowProps = {
  count: number;
  name: string;
  amount: number;
  currency: Currency;
};

const MultiplicationSign = styled.div`
  ::before {
    content: '×';
    margin: 0 4px;
    font-size: 13px;
  }
`;
const OptionValue = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px 0;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;
const Text = styled.div`
  ${typographyCss.Body3};
  letter-spacing: 0.15px;
  color: ${cbSemanticCssVars.textPrimary};
`;
const OptionValueDescription = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const OptionValueCount = styled(Text)`
  display: flex;
  min-width: 36px;
  font-weight: bold;
`;
const OptionValueName = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
`;
const OptionValuePrice = styled(Text)``;

const ItemOptionValueRow = ({ count, name, amount, currency }: ItemOptionValueRowProps) => (
  <OptionValue>
    <OptionValueDescription>
      <OptionValueCount>
        {count} <MultiplicationSign />
      </OptionValueCount>
      <OptionValueName>{name}</OptionValueName>
    </OptionValueDescription>
    <OptionValuePrice>
      <MonetaryAmount amount={amount} currency={currency} />
    </OptionValuePrice>
  </OptionValue>
);

export default ItemOptionValueRow;
